import React from 'react'

const PersonCheckIcon = ({ color = '#1890FF' }: { color?: string }) => {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.28711 11.4721L10.0531 13.2381L13.5851 9.70605"
        stroke={color}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.52107 6.17398C7.98407 6.17398 9.17007 4.98798 9.17007 3.52498C9.17007 2.06197 7.98407 0.875977 6.52107 0.875977C5.05807 0.875977 3.87207 2.06197 3.87207 3.52498C3.87207 4.98798 5.05807 6.17398 6.52107 6.17398Z"
        stroke={color}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0527 9.1576C9.12372 8.39469 7.95369 7.93994 6.68082 7.93994C3.79705 7.93994 1.43845 10.2755 1.22266 13.2379H7.52378"
        stroke={color}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default PersonCheckIcon
